export default {
  authenticatorCodeOne: 'Authenticator code 1',
  authenticatorCodeTwo: 'Authenticator code 2',
  authenticatorCodeTwoInfo: 'Wait 30 seconds and enter a second code',
  backupCodesRegenerated: {
    title: 'Backup codes regenerated successfully',
    message: `Please save the following 8 backup codes in a safe place:  
{{backupCodes}}  

Use them to access your account if you lose access to your authenticator device.  
**Every backup code can be used only once**.  
They can only be viewed now, so make sure to **save them now**.`,
  },
  create: {
    label: 'Create',
  },
  creationSuccessful: {
    title: '2FA device created successfully',
    message: `2FA device "{{deviceName}}" has been created.  
$t(user2FADevice:backupCodesRegenerated.message)`,
  },
  deletion: {
    confirm: 'Are you sure you want to delete the device "{{deviceName}}"?',
    error: 'Error deleting device: {{message}}',
    successful: 'Device deleted successfully',
  },
  deviceName: 'Device name',
  deviceNameFinal: 'Device name shown in Auth APP',
  enabled: 'Enabled',
  error: {
    fetchDevice: 'Error fetching device details: {{message}}',
    createDevice: 'Error creating device: {{message}}',
    updateDevice: 'Error updating device: {{message}}',
    regenerateBackupCodes: 'Error regenerating backup codes: {{message}}',
  },
  regenerateBackupCodes: {
    label: 'Regenerate backup codes',
    confirm: `Are you sure you want to regenerate backup codes for device "{{deviceName}}"?  
The previous backup codes will no longer work.`,
  },
  showSecretKey: 'Show secret key',
  validation: {
    label: 'Validate',
    successful: 'Device validated successfully',
    error: 'Invalid authenticator codes',
  },
  validationSteps: {
    installAuthenticatorApp: {
      title: 'Install Authenticator App',
      description: 'Install an authenticator app on your mobile device (e.g. Google Authenticator, Authy, etc.).',
    },
    scanCode: {
      title: 'Scan QR Code',
      description: 'Use the authenticator app to scan the QR code shown below.',
      descriptionAlternative: 'Alternatively, you can enter the secret key in the authenticator app.',
    },
    typeAuthenticatorCodes: {
      title: 'Enter Authenticator Codes',
      description: 'Enter two consecutive codes generated by the authenticator app to validate the device.',
    },
  },
}
